
import React from "react";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
}

export function LoadingSpinner({ size = "md" }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: "h-2 w-2",
    md: "h-3 w-3",
    lg: "h-4 w-4"
  };
  
  return (
    <div className="flex justify-center items-center py-1">
      <div className="flex space-x-2">
        <div className={`animate-bounce rounded-full bg-black ${sizeClasses[size]} delay-0`}></div>
        <div className={`animate-bounce rounded-full bg-black ${sizeClasses[size]} delay-150`}></div>
        <div className={`animate-bounce rounded-full bg-black ${sizeClasses[size]} delay-300`}></div>
      </div>
    </div>
  );
}
